<template>
  <div class="pb__container">
    <div class="pb__bar">
      <div
        class="pb__progress"
        :style="{ width: value + '%'}"
      ></div>
      <div class="pb__background"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Number, default: 0 }
  }
}
</script>

<style lang="scss" scoped>
  .pb {
    &__container {
      height: 14px;
      border-radius: 30px;
      overflow: hidden;
    }

    &__bar {
      position: relative;
      display: flex;
      gap: 1px;
      width: 100%;
      height: 100%;
    }

    &__progress {
      width: 100px;
      border-radius: 30px;
      background: linear-gradient(90deg, #10BCA6 0%, #20BF55 100%);
    }

    &__background {
      flex: 1;
      background: #C4C4C4;
      border-radius: 30px;
    }

    &__progress,
    &__background {
      position: relative;

      &:after {
        content: '';
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: calc(100% - 20px);
        height: 30%;
        border-radius: 30px;
        background: rgba(#fff, .2);
      }
    }
  }
</style>